import Mountain1 from "../assets/1.jpg";
import Mountain2 from "../assets/2.jpg";
import Mountain3 from "../assets/5.jpg";
import Mountain4 from "../assets/8.jpg";
import DestinationData from "./DestinationData";
import "./DestinationStyles.css";

const Destination = () => {
  return (
    <div className="destination">
      <h1>Popular Destinations</h1>
      <p>Tours and have fun</p>

      <DestinationData
      className="first-des"
         heading="Taal Volcano, Batangas"
         text="Taal Volcano is a complex volcano located on the island of Luzon in the Philippines. It is situated in the province of Batangas and is known for its picturesque crater lake. Taal is one of the world's smallest active volcanoes, yet it is one of the most dangerous due to its potential for explosive eruptions. The volcano has been the site of numerous eruptions throughout history, with the most recent major eruption occurring in January 2020, affecting nearby communities and prompting evacuations. Despite its risks, Taal Volcano is a popular tourist destination, attracting visitors who come to admire its natural beauty and geological significance."
         img1={Mountain1}
         img2={Mountain2}
      
      />

<DestinationData
className="first-des-reverse"
         heading="Mt.Daguldul, Batangas"
         text="Mount Daguldol is a mountain located in the province of Batangas, Philippines. It is part of the Bicol Volcanic Chain and is situated within the municipality of San Juan. Mount Daguldol is known for its scenic hiking trails, lush forests, and stunning views of the surrounding landscapes, including nearby beaches and the Verde Island Passage. It is a popular destination for outdoor enthusiasts, offering various hiking routes that cater to both beginners and experienced hikers. The mountain's summit provides panoramic vistas of the surrounding areas, making it a rewarding destination for adventurers seeking nature and tranquility."
         img1={Mountain3}
         img2={Mountain4}
      
      />
      </div>
  );
};

export default Destination;
